/* eslint-disable */
import React,{PureComponent} from 'react'
import PropTypes from 'prop-types'
import Row from './Row'


class CompanyGroup extends PureComponent {

  state = {collapsed:true};

  toggleCompany = ()=>{
    this.setState({collapsed: !this.state.collapsed})
  };

  setCollapsed = ({isSingleCompany})=>{
    // Expand group if single company returned
    // from search
    // =======================================
    this.setState({collapsed:!isSingleCompany})
  };

  componentWillMount() {
    // Initial Render
    // ==============
    this.setCollapsed(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setCollapsed(nextProps)
  }

  renderCompany = ()=>{
    const {data} = this.props;
    const {collapsed} = this.state;
    if(collapsed) return <noop></noop>;

    // Show Company Payments
    // =====================
    return (
      <div className="panel-body">
        <table className="table table-responsive table-condensed table-hover">
          <thead>
          <tr>
            <th>Invoice Received</th>
            <th>Invoice ID</th>
            <th>Scheduled Pay Date</th>
            <th>Check No.</th>
            <th>Paid</th>
          </tr>
          </thead>
          <tbody>
          {data.map((row,i)=>{
            return <Row key={`Vendor-Payment-Row-${i}`} data={row} />
          })}
          </tbody>
        </table>
      </div>
    )
  };

  render(){
    const {company} = this.props;
    const {collapsed} = this.state;
    // Set arrow direction for collapsed
    // =================================
    let arrowClass = 'glyphicon ';
    if(collapsed) {
      arrowClass += 'glyphicon-chevron-right';
    } else {
      arrowClass += 'glyphicon-chevron-down';
    }

    return (
      <div className="panel-body">
        <a onClick={this.toggleCompany}>
          <h4>
            <span className={arrowClass} aria-hidden="true"></span>
            &nbsp;{company}
            </h4>
        </a>
        {this.renderCompany()}
      </div>
    )
  }
}

CompanyGroup.defaultProps = {
  isSingleCompany: false,
  company:'',
  data:[]
};

CompanyGroup.propTypes = {
  isSingleCompany: PropTypes.bool.isRequired,
  company: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
};

export default CompanyGroup


// WEBPACK FOOTER //
// ./src/components/Payments/CompanyGroup.jsx